import { Avatar, Box, Text } from "@chakra-ui/react";

import { formatDateSimple } from "../../../utils/formatDate";

interface Company {
  color: string;
}

interface Bonuses {
  name: string;
  bonuses_message?: string;
  total_visits: number;
}
interface CouponProps {
  code: string;
  expiration_date: Date;
  logo: string;
  client: {
    name: string;
  };
  bonus: Bonuses;
  company: Company;
  is_falae: boolean;
}

export function Coupon({
  bonus,
  client,
  code,
  expiration_date,
  company,
  logo,
}: CouponProps) {
  return (
    <Box
      id="coupon"
      display="flex"
      flexDirection="column"
      flexWrap="nowrap"
      m="0"
      p="0"
      fontFamily="sans-serif"
      fontSize="base"
      bg="white"
      h="430px"
      w="320px"
      border="1px solid black"
      zIndex="10"
    >
      <Box
        display="flex"
        flex="1"
        alignItems={code.length > 80 ? "start" : "center"}
        justifyContent="center"
        borderBottom="4px solid"
        bg="black"
        minH="60px"
        py={code.length > 80 ? "1" : "0"}
        px={code.length > 80 ? "1" : "0"}
        style={{ borderColor: company.color }}
      >
        <Text
          color="white"
          textAlign="center"
          fontSize={code.length > 60 ? "sm" : code.length > 30 ? "md" : "lg"}
          noOfLines={code.length > 60 ? 3 : code.length > 30 ? 2 : 1}
        >
          <b>ID: </b> {code}
        </Text>
      </Box>
      <Box
        display="flex"
        position="relative"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        h="64px"
        zIndex="10"
      >
        <Box
          position="absolute"
          h="95px"
          w="95px"
          borderRadius="full"
          overflow="hidden"
          top="-16px"
        >
          <Avatar
            boxSize="full"
            objectFit="cover"
            borderRadius="full"
            src={logo}
          />
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        flexWrap="nowrap"
        alignItems="center"
        justifyContent="space-around"
        w="full"
        minH="210px"
        px="2"
        color="black"
      >
        <Text fontSize="15px" mt="3">
          <b>PARABÉNS, </b>
        </Text>
        <Text fontSize="14px">{client.name}</Text>
        <Text fontSize="15px">
          <b>VOCÊ GANHOU</b>
        </Text>
        <Text fontSize="14px">{bonus.name}</Text>
        {bonus.bonuses_message ? (
          <Box
            textAlign="center"
            w="full"
            maxH="70px"
            overflow="hidden"
            wordBreak="break-word"
            my="2"
            fontSize={bonus.bonuses_message.length > 70 ? "sm" : "md"}
          >
            <Box
              dangerouslySetInnerHTML={{
                __html: bonus.bonuses_message,
              }}
            />
          </Box>
        ) : (
          <Text fontSize="12px" textAlign="center">
            PARA O NOSSO PRÓXIMO ENCONTRO
          </Text>
        )}
        <Text fontSize="14px" textAlign="center">
          <b>Validade: </b> {formatDateSimple(expiration_date)}
        </Text>
      </Box>
      <Box
        flex="1"
        w="full"
        borderTop="2px solid"
        bg="black"
        minH="60px"
        style={{ borderColor: company.color }}
      />
    </Box>
  );
}
